import { useQuery } from '@tanstack/react-query';
import { fetchDailyRoute, type DailyRouteParams } from '@apis/reports';

/**
 * Read the daily route report for a single subject (tag or equipment) on the
 * given date. Cache key isolates per (site, kind, entity, date) so navigating
 * between subjects doesn't refetch unchanged routes.
 */
export function useDailyRouteQuery(params: DailyRouteParams) {
  return useQuery({
    queryKey: [
      'reports',
      'daily-route',
      params.siteId,
      params.entityKind,
      params.entityId,
      params.date,
    ],
    queryFn: ({ signal }) => fetchDailyRoute(params, signal),
    enabled: !!params.siteId && !!params.entityId && !!params.date,
    staleTime: 5 * 60 * 1000,
  });
}
